// LIBRARIES
import styled, { css } from "styled-components";
// MISC
import { COLORS, BORDER_RADIUS, SIZE, DEVICE_TYPE } from "constants/variables";
import cursorIcon from "assets/img/Cursor.png";
import { HeaderTabTypes } from "./HeaderTabModel";

export const HeaderTabwrapper = styled.div<{
  type?: HeaderTabTypes;
  hasFilters?: boolean;
  $customFilters?: boolean;
}>`
  background-color: ${COLORS.VividAuburn};
  border-top-right-radius: ${BORDER_RADIUS.radius24};
  border-top-left-radius: ${BORDER_RADIUS.radius24};
  padding: 0 ${SIZE.max78};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: ${SIZE.max60};
  z-index: 1;
  ${({ type }) =>
    type === HeaderTabTypes.WhiteTheme &&
    css`
      background-color: ${COLORS.Background};
    `}
  @media(max-width: ${DEVICE_TYPE.mobileHeader}) {
    padding: ${({ hasFilters }) => hasFilters === true && "0 128px"};
    border-top-right-radius: 0px;
    border-top-left-radius: 0px;
  }
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    padding: ${({ hasFilters }) => hasFilters === true && "0 24px"};
    border-radius: 0px;
  }
  ${({ $customFilters }) => $customFilters && css`
    gap: 24px;
    padding: 12px 24px;
    border-radius: ${BORDER_RADIUS.radius24};
    @media (max-width: 1100px) {
      flex-direction: column;
      align-items: stretch;
      gap: 12px;
      padding: 12px 20px;
      border-radius: ${BORDER_RADIUS.radius24};
    }
    @media (max-width: ${DEVICE_TYPE.mobile}) {
      padding: 12px 16px;
      border-radius: ${BORDER_RADIUS.radius24};
    }
  `}
`;

export const HeaderCell = styled.div<{
  type: HeaderTabTypes;
  isSelected: boolean;
  biggerCursor?: boolean;
  hasFilters?: boolean;
  $compact?: boolean;
}>`
  color: ${({ type }) =>
    type === HeaderTabTypes.RedTheme ? COLORS.Cultured : COLORS.RaisinBlack};
  padding: 21px 0;
  line-height: 0;
  z-index: 2;
  position: relative;
  width: ${({ hasFilters }) => (hasFilters === true ? "90px" : "auto")};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 150px;
  word-wrap: break-word;
  ${({ isSelected, biggerCursor }) => css`
    ${!isSelected &&
    css`
      &:hover {
        color: ${({ type }) =>
          type === HeaderTabTypes.RedTheme
            ? COLORS.RaisinBlack
            : COLORS.MetalicSilver};
        transition: 0.3s ease-in-out;
        cursor: ${biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
      }
    `}
    &::after {
      content: "";
      position: absolute;
      bottom: -2px;
      width: ${isSelected ? "100%" : "0%"};
      height: 4px;
      background-color: ${COLORS.Yellow};
      border-radius: ${BORDER_RADIUS.radius21};
      transform-origin: center;
      transition: width 0.3s ease-in-out;
    }
    ${isSelected &&
    css`
      color: ${({ type }) =>
        type === HeaderTabTypes.RedTheme ? COLORS.Yellow : COLORS.VividAuburn};
    `}
  `}
  ${({ $compact }) => $compact && css`
    padding: 10px 0;
    width: auto;
    max-width: none;
    white-space: nowrap;
    line-height: normal;
    &::after { height: 3px; bottom: 0; }
    @media (max-width: ${DEVICE_TYPE.mobile}) {
      white-space: normal;
      padding: 4px 0 10px;
      min-height: 44px;
      flex: 1;
      align-items: flex-start;
      > * { line-height: 1.35; }
    }
  `}
`;

export const TabWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${SIZE.max40};
  overflow-x: scroll;
  overflow-y: hidden;
`;

export const FiltersWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${SIZE.max40};
`;
